import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { BaseAllParam, SaveServiceParamParams, UpdateyuntuParams, yuntuDeleteServiceParamParams, yuntuCustomerAreaSaveParams } from '@/typings/api/systemSetting'

/**
 * **************************************  **************************************
 */
// 云途客户区域树
export function baseAll(data:BaseAllParam) {
  return request.post<AxiosResult>('/base/api/customerArea/all', data)
}
export function saveServiceParam(data:SaveServiceParamParams) {
  return request.post<AxiosResult>('/base/api/customerArea/save', data)
}
export function updateServiceParam(data:UpdateyuntuParams) {
  return request.post<AxiosResult>('/base/api/customerArea/update', data)
}
export function deleteServiceParam(data:yuntuDeleteServiceParamParams) {
  return request.post<AxiosResult>('/base/api/customerArea/delete', data)
}
export function getIdServiceParam(params:yuntuDeleteServiceParamParams) {
  return request.get<AxiosResult<yuntuCustomerAreaSaveParams>>('/base/api/customerArea/getByAreaId', { params })
}
